import { useEffect, useState } from 'react'
import api from 'services/api'
import { useTokenApi } from './useTokenApi'

interface props {
  url: string
  page?: number
  active?: boolean
}

export function useFetch<T = unknown>({ url, page, active = true }: props) {
  const [data, setData] = useState<any>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)
  const { deleteTokenApi } = useTokenApi()

  const getApi = async () => {
    try {
      setLoading(true)
      const { data } = await api.get(url)
      await setData(data)
    } catch (e: any) {
      if (e?.response?.status === 401) {
        deleteTokenApi()
      }
      console.log(e)
      setError(true)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (active) {
      getApi()
    }
  }, [page, active, url])

  return { data, loading, error }
}
